<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <div class="mb-4 d-flex align-items-center justify-content-between laporan-periode-wrapper">
                <div class="laporan-periode">
                    <h4>Laporan Pemasukan</h4>
                    <h6>
                        Periode : 
                        <span>{{$helper.changeDateFormat(periodeStart)}}</span>
                        <span v-if="periodeEnd != ''"> - {{$helper.changeDateFormat(periodeEnd)}}</span>
                    </h6>
                </div>
                <b-button variant="pgiBtn" class="mb-0 download-btn" @click="openModalDownload()">
                    <i class="fa fa-download mr-2"></i>
                    Download Excel
                </b-button>
            </div>
            <b-row>
                <b-col md="3" sm="4" cols="12">
                    <div class="custom-card-dashboard balance-card">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="card-data">
                                <p class="mb-0 text-muted">Jasa</p>
                                <strong class="mb-0">
                                    Rp. {{$helper.addThousandSeparator(dataPemasukanGadaiAll.jasa)}}
                                </strong>
                            </div>
                            <div class="ml-2 card-icon">
                                <i class="fa fa-handshake-o"></i>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="4" cols="12">
                    <div class="custom-card-dashboard balance-card">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="card-data">
                                <p class="mb-0 text-muted">Admin</p>
                                <strong class="mb-0">
                                    Rp. {{$helper.addThousandSeparator(dataPemasukanGadaiAll.admin)}}
                                </strong>
                            </div>
                            <div class="ml-2 card-icon">
                                <i class="fa fa-user-o"></i>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="4" cols="12">
                    <div class="custom-card-dashboard balance-card">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="card-data">
                                <p class="mb-0 text-muted">Denda</p>
                                <strong class="mb-0">
                                    Rp. {{$helper.addThousandSeparator(dataPemasukanGadaiAll.denda)}}
                                </strong>
                            </div>
                            <div class="ml-2 card-icon">
                                <i class="fa fa-minus"></i>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="4" cols="12">
                    <div class="custom-card-dashboard balance-card">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="card-data">
                                <p class="mb-0 text-muted">Penalti</p>
                                <strong class="mb-0">
                                    Rp. {{$helper.addThousandSeparator(dataPemasukanGadaiAll.penalti)}}
                                </strong>
                            </div>
                            <div class="ml-2 card-icon">
                                <i class="fa fa-fire"></i>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="4" cols="12">
                    <div class="custom-card-dashboard balance-card">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="card-data">
                                <p class="mb-0 text-muted">Keringanan</p>
                                <strong class="mb-0">
                                    Rp. {{$helper.addThousandSeparator(dataPemasukanGadaiAll.keringanan)}}
                                </strong>
                            </div>
                            <div class="ml-2 card-icon">
                                <i class="fa fa-cut"></i>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="4" cols="12">
                    <div class="custom-card-dashboard balance-card">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="card-data">
                                <p class="mb-0 text-muted">Angsuran Pokok</p>
                                <strong class="mb-0">
                                    Rp. {{$helper.addThousandSeparator(dataPemasukanGadaiAll.angsuranPokok)}}
                                </strong>
                            </div>
                            <div class="ml-2 card-icon">
                                <i class="fa fa-calendar-o"></i>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="4" cols="12">
                    <div class="custom-card-dashboard balance-card">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="card-data">
                                <p class="mb-0 text-muted">Pokok</p>
                                <strong class="mb-0">
                                    Rp. {{$helper.addThousandSeparator(dataPemasukanGadaiAll.pokok)}}
                                </strong>
                            </div>
                            <div class="ml-2 card-icon">
                                <i class="fa fa-diamond"></i>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="4" cols="12">
                    <div class="custom-card-dashboard balance-card">
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="card-data">
                                <p class="mb-0 text-muted">Total</p>
                                <strong class="mb-0">
                                    Rp. {{$helper.addThousandSeparator(dataPemasukanGadaiAll.total)}}
                                </strong>
                            </div>
                            <div class="ml-2 card-icon">
                                <i class="fa fa-calculator"></i>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-card >
                <template v-slot:header>
                    <h5>Laporan Pemasukan Cabang</h5>
                </template>
                <div class="search-wrapper d-flex align-items-center justify-content-between">
                    <b-form-group
                        label="Filter"
                        label-for="filterInput"
                        class="form-inline form-group-wrapper mb-3"
                    >   
                        <div class="d-flex search-input-wrapper">
                            <multiselect
                                class="ml-2 mr-2"
                                name="filterCabang"
                                v-model="input.filterCabang" 
                                :options="cabangOption" 
                                :internal-search="true"
                                :allow-empty="true"
                                deselect-label=""
                                select-label=""
                                label="name"
                                track-by="name"
                                placeholder="-- Pilih filter cabang --"
                            />
                            <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter()"> 
                                <i class="fa fa-search"></i>
                            </b-button>
                            <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
                        </div>
                    </b-form-group>
                </div>
                <b-table bordered hover show-empty
                    :busy="isBusy"
                    :items="dataPemasukanGadai" 
                    :fields="fields" 
                    :currentPage="currentPage" 
                    :perPage="perPage"
                    responsive class="mb-3">
                    <template v-slot:table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>  Loading data...</strong>
                        </div>
                    </template>
                    <template v-slot:empty>
                        Tidak ada data pemasukan.
                    </template>
                    <template v-slot:cell(jasa)="row">
                        <div class="text-right no-wrap" v-if="row.item.jasa == null">{{$helper.addThousandSeparator(row.item.jasa)}} </div>
                        <div class="text-right no-wrap" v-else-if="row.item.jasa < 0">- Rp{{$helper.addThousandSeparator(row.item.jasa).replace("-", "")}}</div>
                        <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.jasa)}} </div>
                    </template>
                    <template v-slot:cell(admin)="row">
                        <div class="text-right no-wrap" v-if="row.item.admin == null">{{$helper.addThousandSeparator(row.item.admin)}} </div>
                        <div class="text-right no-wrap" v-else-if="row.item.admin < 0">- Rp{{$helper.addThousandSeparator(row.item.admin).replace("-", "")}}</div>
                        <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.admin)}} </div>
                    </template>
                    <template v-slot:cell(denda)="row">
                        <div class="text-right no-wrap" v-if="row.item.denda == null">{{$helper.addThousandSeparator(row.item.denda)}} </div>
                        <div class="text-right no-wrap" v-else-if="row.item.denda < 0">- Rp{{$helper.addThousandSeparator(row.item.denda).replace("-", "")}}</div>
                        <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.denda)}} </div>
                    </template>
                    <template v-slot:cell(penalti)="row">
                        <div class="text-right no-wrap" v-if="row.item.penalti == null">{{$helper.addThousandSeparator(row.item.penalti)}} </div>
                        <div class="text-right no-wrap" v-else-if="row.item.penalti < 0">- Rp{{$helper.addThousandSeparator(row.item.penalti).replace("-", "")}}</div>
                        <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.penalti)}} </div>
                    </template>
                    <template v-slot:cell(keringanan)="row">
                        <div class="text-right no-wrap" v-if="row.item.keringanan == null">{{$helper.addThousandSeparator(row.item.keringanan)}} </div>
                        <div class="text-right no-wrap" v-else-if="row.item.keringanan < 0">- Rp{{$helper.addThousandSeparator(row.item.keringanan).replace("-", "")}}</div>
                        <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.keringanan)}} </div>
                    </template>
                    <template v-slot:cell(angsuranPokok)="row">
                        <div class="text-right no-wrap" v-if="row.item.angsuranPokok == null">{{$helper.addThousandSeparator(row.item.angsuranPokok)}} </div>
                        <div class="text-right no-wrap" v-else-if="row.item.angsuranPokok < 0">- Rp{{$helper.addThousandSeparator(row.item.angsuranPokok).replace("-", "")}}</div>
                        <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.angsuranPokok)}} </div>
                    </template>
                    <template v-slot:cell(pokok)="row">
                        <div class="text-right no-wrap" v-if="row.item.pokok == null">{{$helper.addThousandSeparator(row.item.pokok)}} </div>
                        <div class="text-right no-wrap" v-else-if="row.item.pokok < 0">- Rp{{$helper.addThousandSeparator(row.item.pokok).replace("-", "")}}</div>
                        <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.pokok)}} </div>
                    </template>
                    <template v-slot:cell(total)="row">
                        <div class="text-right no-wrap" v-if="row.item.total == null">{{$helper.addThousandSeparator(row.item.total)}} </div>
                        <div class="text-right no-wrap" v-else-if="row.item.total < 0">- Rp{{$helper.addThousandSeparator(row.item.total).replace("-", "")}}</div>
                        <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.total)}} </div>
                    </template>
                </b-table>

                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                        <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled />
                            </template>
                        </b-form-select>
                        <span class="ml-2">{{ totalViewText }}</span>
                    </b-input-group>
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                        @input="onPageChange"
                    ></b-pagination>
                </div>
            </b-card>
        </div>
        <b-modal id="modal-download-excel" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoadLink == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'detail-laporan-gadai-baru',
    data() {
        return {
            initStatus: 1,
            isBusy: true,
            input:{
                show: 10,
                filterCabang: null,
            },
            fields: [
                { key: "cabangName", label: "Cabang", sortable: true },
                { key: "jasa", label: "Jasa", sortable: true },
                { key: "admin", label: "Admin", sortable: true },
                { key: "denda", label: "Denda", sortable: true },
                { key: "penalti", label: "Penalti", sortable: true },
                { key: "keringanan", label: "Keringanan", sortable: true },
                { key: "angsuranPokok", label: "Angsuran Pokok", sortable: true },
                { key: "pokok", label: "Pokok", sortable: true },
                { key: "total", label: "Total", sortable: true },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            dataPemasukanGadaiAll : [],
            dataPemasukanGadai: [],
            filePath: "",
            cabangOption: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            id: '',
            periodeStart: '',
            periodeEnd: '',
            isLoadLink: false,
            filePathDownload: ""
        }
    }, 
    methods: {
        
        init() {
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show

            this.id = this.$route.params.id

            let getCabang = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    if(element.id != this.srcCabangId)
                        this.cabangOption.push(element)
                })
            })

            let getDataPemasukan = this.$axios.get(`laporan-eksekutif/pemasukan/?${this.id}`).then(response => {
                this.dataPemasukanGadaiAll = response.data
                this.dataPemasukanGadai = response.data.entries
                this.updateTotalItem()
       
            })

            Promise.all([getCabang, getDataPemasukan]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
                this.periodeStart = this.id.slice(10, 20)
                if(this.id.length > 21){
                    this.periodeEnd = this.id.slice(29)
                }
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDataPemasukan(){
            this.dataPemasukanGadai = this.dataPemasukanGadaiAll.entries
            this.toggleBusy()
            this.updateTotalItem()
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onReset(){
            this.input.filterCabang = null
            this.toggleBusy()
            this.getDataPemasukan()
        },
        
        onFilter(){
            
            if(this.input.filterCabang == null){
                this.$helper.toastErr(this, "Silakan isi nama cabang terlebih dahulu!")
            }else{
                let filteredArray = []

                for (var x of this.dataPemasukanGadaiAll.entries) {
                    if(x.cabangId == this.input.filterCabang.id){
                        filteredArray.push(x)
                    }
                }
                
                this.dataPemasukanGadai = filteredArray
                this.onFiltered(this.dataPemasukanGadai)
            }
        },

        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
            this.perPage = this.input.show
            let prevLimit = null
            let limit = null
            
            prevLimit = (this.currentPage-1) * this.rows + 1
            limit = (this.currentPage-1) * this.rows + this.rows
            if (limit > this.input.show) limit = this.input.show
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(){
            this.rows = this.dataPemasukanGadai.length
            if (this.perPage > this.rows) this.perPage = this.rows
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },

        openModalDownload(){

            this.isLoadLink = true

            this.$axios.get(`laporan-eksekutif/pemasukan/dl/?${this.id}`).then(response => {
                
                this.$bvModal.show('modal-download-excel')
                this.filePathDownload = response.data
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isLoadLink = false
            })
        }
    },
    created() {
        this.init()
    }
}
</script>
